<script setup lang="ts">
import type { DividerProps } from '/#/components/base/divider'
import type { ComputedRef } from 'vue'

import get from 'lodash-es/get'

import Button from '/@/components/base/button/Button.vue'
import Buttons from '/@/components/base/button/Buttons.vue'
import Dropdown from '/@/components/base/dropdown/Dropdown.vue'

const props = withDefaults(defineProps<DividerProps>(), {
  dashed: false,
  vertical: false,
})

const slots = useSlots()

const dividerComponents = {
  Button: Button,
  Buttons: h(Buttons, props.componentProps, {
    default: () => slots.default,
  }),
  Dropdown: Dropdown,
  Text: h('span', props.componentProps?.text),
}

const componentToRender = computed(() => {
  return get(dividerComponents, props.component as string)
})

// For dynamic class binding
const appearance: ComputedRef<any> = computed(() => [
  { dashed: props.dashed },
  { vertical: props.vertical },
])
</script>

<template>
  <div v-if="slots.default" class="divider-wrapper" :class="appearance">
    <slot />
  </div>
  <div v-else-if="component" class="divider-wrapper" :class="appearance">
    <Component v-bind="componentProps" :is="componentToRender" v-on="componentEmits" />
  </div>
  <hr v-else :class="appearance" />
</template>
